/* eslint-disable */

!((document, Drupal, $, once) => {
  Drupal.behaviors.paleoToggleBox = {
    attach: function (context, settings) {

      // eslint-disable-next-line max-len
      $(once('toggleBox', 'body', context)).each(function () {

        // Init Variable
        var openTab = "",
          openToggle = new Array(),
          openSlides = new Array(),
          alreadyOpenToggle = new Array();

        // Event listener on Uikit switcher.
        UIkit.util.on('.uk-switcher', 'beforeshow', function (ev) {
          // If it's not about the accordion
          if (!$(ev.detail[0].$el).hasClass('uk-accordion')) {

            // Find tab children
            $('.node-practical-information [data-parent="' + openTab + '"]').each(function () {
              const val = $(this).data('toggle');
              if (val !== undefined) {
                // If open slide is a child of this tab, open it. First first.
                if (openSlides.includes(val)) {
                  ev.preventDefault();
                  selectSlide(val);
                  return false;
                }
              }
            });
          }
        });

        /**
         * Init click listener
         */
        $(context).find('[uk-accordion] .uk-accordion-title').click(function () {
          toggleBox($(this).parent().attr("data-toggle-id"), false, false, false);
        });

        $(context).find('.paragraph-toggle-box [data-tags]').click(function () {
          selectSlide($(this).attr("data-tags"));
        });

        $(context).find('[uk-switcher] > .tab-item').click(function () {
          selectTab($(this).attr("data-tags"));
        });

        $(context).on('click', '.button-back', function() {
          let $tag = $(this).closest('.node-practical-information').attr('data-toggle');
          closeSlide($tag, openTab);
        });

        /**
         * Get links that href to local toggles
         */
        $(context).find('[uk-accordion] .uk-accordion-title').each(function (index, value) {
          var $this = $(this);
          var id = $this.parent().attr('data-toggle-id');

          $('a[href="#' + id + '"]').click(function (e) {
            e.preventDefault();
            toggleBox(id, true, true);
          });
        });

        /*
         * Event on click to the tab
         */
        function selectTab(id) {
          openTab = id;

          let $switcherElement = $('[data-tags=' + id + ']');
          if ($switcherElement.length) {
            let $switcher = $switcherElement.parent('[uk-switcher]');
            if ($switcher.length) {
              // Before will be launch and will check for slide.
              UIkit.switcher($switcher).show($switcherElement);
            }
          }

          updateHashTag();
          reloadIFrame();
        }

        /**
         * Event on click on a toggle that reference a practical info.
         * @param id practical info content
         */
        function selectSlide(id) {
          if (!openSlides.includes(id)) {
            openSlides.push(id);
          }

          // Fill the slide container.
          $('.slide-container').empty();
          $('.slide-container').append($('[data-slide-content=' + id + ']').html());

          // Then show it.
          $(context).find('.uk-switcher .tab-content').removeClass('uk-active');
          $('.slide-container').addClass('uk-active');

          updateHashTag();
          reloadIFrame();
        }

        /**
         * Event on click on slide back button
         * @param tag practical info content
         * @param parent practical info content parent (tab)
         */
        function closeSlide(tag, parent) {
          openSlides = openSlides.filter(function(item) {
            return item !== tag;
          });

          selectTab(parent);
          updateHashTag();
          reloadIFrame();
        }

        /*
         * Refresh visible iframe to prevent error with google map zoom
         */
        function reloadIFrame() {
          if (openTab) {
            $(context).find('.tab-content[data-tags=' + openTab + '].uk-active').each(function () {
              var $this = $(this);
              var id = $(this).attr('data-toggle-id');
              if ($.inArray(id, alreadyOpenToggle) < 0) {
                alreadyOpenToggle.push(id);
                $this.find("iframe").attr('src', function (i, val) {
                  return val;
                });
              }
            });
          }
        }

        /*
         * Event on click to a box
         */
        function toggleBox(id, onlyToVisible, scrollTo, toOpenClose) {
          var $box = $(context).find('[data-toggle-id=' + id + ']'),
            $content = $(context).find('[data-toggle-id=' + id + '] .uk-accordion-content'),
            arrayIndex = openToggle.indexOf(id),
            onlyToVisible = typeof onlyToVisible === 'undefined' ? false : onlyToVisible,
            scrollTo = typeof scrollTo === 'undefined' ? false : scrollTo,
            toOpenClose = typeof toOpenClose === 'undefined' ? true : toOpenClose;

          if ($content.length === 0) {
            return;
          }

          if ($box.hasClass('uk-open')) {
            if (onlyToVisible) {
              return;
            }

            if (toOpenClose) {
              let $accordion = $box.parent('[uk-accordion]');
              if ($accordion.length) {
                UIkit.accordion($accordion).toggle($box, false);
              }
            }

            if (arrayIndex !== -1) {
              openToggle.splice(arrayIndex, 1);
            }
          } else {
            if (toOpenClose) {
              let $accordion = $box.parent('[uk-accordion]');
              if ($accordion.length) {
                UIkit.accordion($accordion).toggle($box, false);
              }
            }

            if (arrayIndex === -1) {
              openToggle.push(id);
            }

            if (scrollTo) {
              $('html, body').animate({
                scrollTop: $box.offset().top - 10
              }, 800);
            }

          }

          updateHashTag();
          reloadIFrame();
        }

        /**
         * Update the URL hashTag with selected info
         */
        function updateHashTag() {
          var hash = "";

          if (openTab !== "") {
            hash = "tab=" + openTab;
          }

          if (openToggle.length > 0) {
            if (openTab !== "") {
              hash += "&";
            }

            hash += "toggle=";
            for (var i = 0; i < openToggle.length; i++) {
              hash += openToggle[i];
              hash += i === openToggle.length - 1 ? "" : ",";
            }
          }

          if (openSlides.length > 0) {
            hash += "&slide=";
            for (var i = 0; i < openSlides.length; i++) {
              hash += openSlides[i];
              hash += i === openSlides.length - 1 ? "" : ",";
            }
          }

          if (location.hash.indexOf('chatbot') >= 0) {
            hash += ((hash !== '') ? '&' : '') + 'chatbot';
          }

          var href = window.location.protocol + '//' + window.location.hostname + window.location.pathname + window.location.search;

          history.replaceState(undefined, undefined, href + (hash ? '#' + hash : ''));
        }

        /*
         * Read the UrlHashTag on load
         */
        function readHashTag() {
          var params_tmp = location.hash.substr(1).split('&'), params = {};

          params_tmp.forEach(function (val) {
            var splitter = val.split('=');
            if (splitter[1]) {
              var values = splitter[1].split(',');
              if (values.length > 1) {
                params[splitter[0]] = values;
              } else {
                params[splitter[0]] = splitter[1];
              }
            }
          });

          if (typeof (params.slide) != "undefined") {
            openSlides = Array.isArray(params.slide) ? params.slide : [params.slide];
          }

          if (typeof (params.tab) != "undefined") {
            selectTab(params.tab);

            // Normally not needed but the beforeshow listener is not ON during the first reading.
            $('.node-practical-information [data-parent="' + params.tab + '"]').each(function () {
              const val = $(this).data('toggle');
              if (val !== undefined) {
                // If open slide is a child of this tab, open it. First first.
                if (openSlides.includes(val)) {
                  selectSlide(val);
                  return false;
                }
              }
            });

          } else if ($(context).find(".tab-item:first").length > 0) {
            selectTab($(context).find(".tab-item:first").attr("data-tags"));
          }

          if (typeof (params.toggle) != "undefined") {
            if (Array.isArray(params.toggle)) {
              var first = true;
              params.toggle.forEach(function (val) {
                toggleBox(val, true, first);
                if (first) {
                  first = false;
                }
              });
            } else {
              toggleBox(params.toggle, true);
              setTimeout(function () {
                var $toggleBox = $(context).find('[data-toggle-id=' + params.toggle + ']');
                if ($toggleBox.length) {
                  $('html, body').animate({
                    scrollTop: $toggleBox.offset().top - 10
                  }, 800);
                }
              }, 500);
            }
          }
        }

        readHashTag();

        // Modern browsers.
        $(window).bind('hashchange', function () {
          readHashTag();
        });
      });
    }
  };

// eslint-disable-next-line no-undef
})(document, Drupal, jQuery, once);
